// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.odd-container {
    /* font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; */
    color: #4a5568;
    /* line-height: 1.6; */
    max-width: 500px;
    margin: 0 auto;
    padding: 10px;
    width: 85%;
}

.odd-description {
    margin-bottom: 10px;
    font-size: 12px;
}

.odd-description strong {
    color: var(--txt-color);
}

/* Contenedor del Diagrama */
.odd-card-visual {
    background-color: #ffffff;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    padding: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;
}

.odd-image {
    max-width: 100%;
    height: auto;
}

/* Caja de Ejemplo */
.odd-example-box {
    background-color: #f8fafc;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    padding: 10px;
    position: relative;
}

.odd-badge {
    background-color: #fef3c7;
    color: #92400e;
    font-size: 0.55rem;
    font-weight: bold;
    padding: 4px 12px;
    border-radius: 6px;
    display: inline-block;
    margin-bottom: 12px;
}

.odd-example-text {
    font-size: 12px;
    margin: 0;
}

.text-red {
    color: #e53e3e;
    font-weight: 600;
}

.odd-example-text strong {
    color: #2d3748;
}

.odd-title {
    /* padding: 10px; */
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: auto;

    color: white;
    border-radius: 4px;


}

.odd-title.up {
    border: 2px solid #0b9515;
    background-color: rgb(122, 255, 151);
    color: #08700f;
}

.odd-title.unkonwn {
    border: 2px solid #5c5c5c;
    background-color: #dedede;
    color: #5c5c5c;
}

.odd-title.down {
    border: 2px solid rgb(240, 0, 191);
    background-color: rgb(252, 158, 233);
    color: rgb(168, 2, 135);
}

.odd-title.odd {
    border: 2px solid #ee0808;
    background-color: #eb7272e1;
    color: #9f0404;
}

.odd-title.exception {
    border: 2px solid #330015c9;
    background-color: #ad1f5aa7;
    color: #330015c9;
}

/* Estilo para la "flechita" que apunta al botón */
.tooltip-arrow::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -8px;
    border-width: 8px;
    border-style: solid;
    border-color: white transparent transparent transparent;
    /* Sombra ligera para la flecha */
    filter: drop-shadow(0 4px 3px rgba(0, 0, 0, 0.07));
}

/* --- Animaciones para el diagrama ODD --- */
.anim-switch {
    animation: switch-fail 4.5s infinite;
}

.anim-cam {
    animation: cam-fail 4.5s infinite;
}

.anim-line {
    animation: line-fail 4.5s infinite;
}

.anim-alert {
    animation: alert-pop 4.5s infinite;
    transform-origin: 145px 10px;
}

@keyframes switch-fail {

    0%,
    25% {
        fill: #10b981;
    }

    /* Estado OK (Verde) */
    30%,
    100% {
        fill: #ef4444;
    }

    /* Estado Fallo / ODD (Rojo) */
}

@keyframes cam-fail {

    0%,
    30% {
        fill: #10b981;
    }

    /* Aún reciben red (Verde) */
    35%,
    100% {
        fill: #94a3b8;
    }

    /* Estado Inalcanzable normal (Gris) */
}

@keyframes line-fail {

    0%,
    25% {
        stroke: #10b981;
        stroke-dasharray: none;
    }

    /* Conectado */
    30%,
    100% {
        stroke: #cbd5e1;
        stroke-dasharray: 4 4;
    }

    /* Desconectado */
}

@keyframes alert-pop {

    0%,
    25% {
        opacity: 0;
        transform: scale(0.5);
    }

    30%,
    40% {
        opacity: 1;
        transform: scale(1.2);
    }

    45%,
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

/* ****************************************DOWN************************************************ */
/* Limitar el tamaño del SVG */
.max-width-down-diagram {
    max-width: 220px;
}

/* Asignación de animaciones */
.anim-switch-down {
    animation: switch-fail-down 4.5s infinite;
}

.anim-cam-down {
    animation: cam-fail-down 4.5s infinite;
}

.anim-line-down {
    animation: line-fail-down 4.5s infinite;
}

.anim-alert-down {
    animation: alert-pop-down 4.5s infinite;
    transform-origin: 145px 10px;
}

/* Keyframes con sufijo -down */
@keyframes switch-fail-down {

    0%,
    25% {
        fill: #10b981;
    }

    /* Verde OK */
    30%,
    100% {
        fill: #ef4444;
    }

    /* Rojo ODD */
}

@keyframes cam-fail-down {

    0%,
    30% {
        fill: #10b981;
    }

    /* Verde OK */
    35%,
    100% {
        fill: #f472b6;
    }

    /* ROSA para indicar dependencia caída */
}

@keyframes line-fail-down {

    0%,
    25% {
        stroke: #10b981;
        stroke-dasharray: none;
    }

    30%,
    100% {
        stroke: #fbcfe8;
        stroke-dasharray: 4 4;
    }

    /* Rosa suave para las líneas */
}

@keyframes alert-pop-down {

    0%,
    25% {
        opacity: 0;
        transform: scale(0.5);
    }

    30%,
    40% {
        opacity: 1;
        transform: scale(1.2);
    }

    45%,
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

/* ************************** UP ****************************** */
.max-width-up-diagram {
    max-width: 220px;
}

/* Estilo base de línea */
.line-up {
    stroke: #10b981;
    stroke-dasharray: 8 4;
    /* Línea punteada */
}

/* Animación de flujo de datos (hormigas marchando) */
.active-flow {
    animation: flow-movement 1s linear infinite;
}

@keyframes flow-movement {
    from {
        stroke-dashoffset: 24;
    }

    to {
        stroke-dashoffset: 0;
    }
}

/* Pulso sutil en el switch para simular "Latido/Ping" */
.ping-pulse {
    animation: ping-ring 2s ease-out infinite;
    opacity: 0;
}

@keyframes ping-ring {
    0% {
        transform: scale(0.8);
        opacity: 0.5;
    }

    100% {
        transform: scale(1.8);
        opacity: 0;
    }
}

/* Efecto de brillo constante en los nodos verdes */
.node-up {
    filter: drop-shadow(0 0 2px rgba(16, 185, 129, 0.4));
}

/* ***************************unknown***************************** */
.max-width-unknown-diagram {
    max-width: 220px;
}

/* Líneas en gris claro y punteadas pero sin movimiento */
.line-unknown {
    stroke: #cbd5e1;
    stroke-dasharray: 2 2;
}

/* Animación de "parpadeo" suave para el signo de interrogación */
.anim-unknown-q {
    animation: unknown-fade 3s infinite ease-in-out;
    transform-origin: 145px 10px;
}

@keyframes unknown-fade {

    0%,
    100% {
        opacity: 0.4;
        transform: scale(0.9);
    }

    50% {
        opacity: 1;
        transform: scale(1.1);
    }
}

/* Nodos en gris neutro */
.node-unknown {
    fill: #94a3b8;
}

/* ********************************Exception************************************** */
.max-width-exception-tags-diagram {
    max-width: 220px;
}

/* Líneas verdes sólidas porque la red física está activa */
.line-exception-tag-ok {
    stroke: #10b981;
    stroke-opacity: 0.7;
}

/* Sombra ligera para las etiquetas para dar efecto 3D (similar a drop-shadow) */
.tag-shadow {
    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));
}

/* Pulso sutil solo en C2 (Mantenimiento crítico) */
.node-mtto-pulse {
    animation: mtto-pulse 2s infinite ease-in-out;
}

@keyframes mtto-pulse {

    0%,
    100% {
        filter: brightness(1);
    }

    50% {
        filter: brightness(1.2);
    }
}

/* Animación de levitación para las etiquetas */
.anim-tag-float {
    animation: tag-float 3s infinite ease-in-out;
}

@keyframes tag-float {

    0%,
    100% {
        transform: translate(var(--original-x, 0px), 45px);
    }

    /* Usamos variables para mantener la posición X */
    50% {
        transform: translate(var(--original-x, 0px), 40px);
    }
}

/* Aplicar la posición original X a cada grupo para la animación */
.cfe-tag-group {
    --original-x: 45px;
}

.mtto-tag-group {
    --original-x: 105px;
}`, "",{"version":3,"sources":["webpack://./src/components/modals-monitoreo/styles/OddInfo.css"],"names":[],"mappings":"AAAA;IACI,kEAAkE;IAClE,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,4BAA4B;AAC5B;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;;IAEZ,YAAY;IACZ,kBAAkB;;;AAGtB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,kDAAkD;AAClD;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,uDAAuD;IACvD,iCAAiC;IACjC,kDAAkD;AACtD;;AAEA,6CAA6C;AAC7C;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;;IAEI;;QAEI,aAAa;IACjB;;IAEA,sBAAsB;IACtB;;QAEI,aAAa;IACjB;;IAEA,8BAA8B;AAClC;;AAEA;;IAEI;;QAEI,aAAa;IACjB;;IAEA,4BAA4B;IAC5B;;QAEI,aAAa;IACjB;;IAEA,sCAAsC;AAC1C;;AAEA;;IAEI;;QAEI,eAAe;QACf,sBAAsB;IAC1B;;IAEA,cAAc;IACd;;QAEI,eAAe;QACf,qBAAqB;IACzB;;IAEA,iBAAiB;AACrB;;AAEA;;IAEI;;QAEI,UAAU;QACV,qBAAqB;IACzB;;IAEA;;QAEI,UAAU;QACV,qBAAqB;IACzB;;IAEA;;QAEI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,iGAAiG;AACjG,8BAA8B;AAC9B;IACI,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,yCAAyC;AAC7C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;IACvC,4BAA4B;AAChC;;AAEA,+BAA+B;AAC/B;;IAEI;;QAEI,aAAa;IACjB;;IAEA,aAAa;IACb;;QAEI,aAAa;IACjB;;IAEA,aAAa;AACjB;;AAEA;;IAEI;;QAEI,aAAa;IACjB;;IAEA,aAAa;IACb;;QAEI,aAAa;IACjB;;IAEA,wCAAwC;AAC5C;;AAEA;;IAEI;;QAEI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;;QAEI,eAAe;QACf,qBAAqB;IACzB;;IAEA,+BAA+B;AACnC;;AAEA;;IAEI;;QAEI,UAAU;QACV,qBAAqB;IACzB;;IAEA;;QAEI,UAAU;QACV,qBAAqB;IACzB;;IAEA;;QAEI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,iEAAiE;AACjE;IACI,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,qDAAqD;AACrD;IACI,2CAA2C;AAC/C;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA,wDAAwD;AACxD;IACI,yCAAyC;IACzC,UAAU;AACd;;AAEA;IACI;QACI,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ;;AAEA,mDAAmD;AACnD;IACI,oDAAoD;AACxD;;AAEA,oEAAoE;AACpE;IACI,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA,iEAAiE;AACjE;IACI,+CAA+C;IAC/C,4BAA4B;AAChC;;AAEA;;IAEI;;QAEI,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,qBAAqB;IACzB;AACJ;;AAEA,yBAAyB;AACzB;IACI,aAAa;AACjB;;AAEA,oFAAoF;AACpF;IACI,gBAAgB;AACpB;;AAEA,2DAA2D;AAC3D;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,gFAAgF;AAChF;IACI,iDAAiD;AACrD;;AAEA,mDAAmD;AACnD;IACI,6CAA6C;AACjD;;AAEA;;IAEI;;QAEI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA,+CAA+C;AAC/C;IACI,4CAA4C;AAChD;;AAEA;;IAEI;;QAEI,kDAAkD;IACtD;;IAEA,iDAAiD;IACjD;QACI,kDAAkD;IACtD;AACJ;;AAEA,kEAAkE;AAClE;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".odd-container {\r\n    /* font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; */\r\n    color: #4a5568;\r\n    /* line-height: 1.6; */\r\n    max-width: 500px;\r\n    margin: 0 auto;\r\n    padding: 10px;\r\n    width: 85%;\r\n}\r\n\r\n.odd-description {\r\n    margin-bottom: 10px;\r\n    font-size: 12px;\r\n}\r\n\r\n.odd-description strong {\r\n    color: var(--txt-color);\r\n}\r\n\r\n/* Contenedor del Diagrama */\r\n.odd-card-visual {\r\n    background-color: #ffffff;\r\n    border: 1px solid #edf2f7;\r\n    border-radius: 12px;\r\n    padding: 30px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.odd-image {\r\n    max-width: 100%;\r\n    height: auto;\r\n}\r\n\r\n/* Caja de Ejemplo */\r\n.odd-example-box {\r\n    background-color: #f8fafc;\r\n    border: 1px solid #edf2f7;\r\n    border-radius: 12px;\r\n    padding: 10px;\r\n    position: relative;\r\n}\r\n\r\n.odd-badge {\r\n    background-color: #fef3c7;\r\n    color: #92400e;\r\n    font-size: 0.55rem;\r\n    font-weight: bold;\r\n    padding: 4px 12px;\r\n    border-radius: 6px;\r\n    display: inline-block;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.odd-example-text {\r\n    font-size: 12px;\r\n    margin: 0;\r\n}\r\n\r\n.text-red {\r\n    color: #e53e3e;\r\n    font-weight: 600;\r\n}\r\n\r\n.odd-example-text strong {\r\n    color: #2d3748;\r\n}\r\n\r\n.odd-title {\r\n    /* padding: 10px; */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: auto;\r\n\r\n    color: white;\r\n    border-radius: 4px;\r\n\r\n\r\n}\r\n\r\n.odd-title.up {\r\n    border: 2px solid #0b9515;\r\n    background-color: rgb(122, 255, 151);\r\n    color: #08700f;\r\n}\r\n\r\n.odd-title.unkonwn {\r\n    border: 2px solid #5c5c5c;\r\n    background-color: #dedede;\r\n    color: #5c5c5c;\r\n}\r\n\r\n.odd-title.down {\r\n    border: 2px solid rgb(240, 0, 191);\r\n    background-color: rgb(252, 158, 233);\r\n    color: rgb(168, 2, 135);\r\n}\r\n\r\n.odd-title.odd {\r\n    border: 2px solid #ee0808;\r\n    background-color: #eb7272e1;\r\n    color: #9f0404;\r\n}\r\n\r\n.odd-title.exception {\r\n    border: 2px solid #330015c9;\r\n    background-color: #ad1f5aa7;\r\n    color: #330015c9;\r\n}\r\n\r\n/* Estilo para la \"flechita\" que apunta al botón */\r\n.tooltip-arrow::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 50%;\r\n    margin-left: -8px;\r\n    border-width: 8px;\r\n    border-style: solid;\r\n    border-color: white transparent transparent transparent;\r\n    /* Sombra ligera para la flecha */\r\n    filter: drop-shadow(0 4px 3px rgba(0, 0, 0, 0.07));\r\n}\r\n\r\n/* --- Animaciones para el diagrama ODD --- */\r\n.anim-switch {\r\n    animation: switch-fail 4.5s infinite;\r\n}\r\n\r\n.anim-cam {\r\n    animation: cam-fail 4.5s infinite;\r\n}\r\n\r\n.anim-line {\r\n    animation: line-fail 4.5s infinite;\r\n}\r\n\r\n.anim-alert {\r\n    animation: alert-pop 4.5s infinite;\r\n    transform-origin: 145px 10px;\r\n}\r\n\r\n@keyframes switch-fail {\r\n\r\n    0%,\r\n    25% {\r\n        fill: #10b981;\r\n    }\r\n\r\n    /* Estado OK (Verde) */\r\n    30%,\r\n    100% {\r\n        fill: #ef4444;\r\n    }\r\n\r\n    /* Estado Fallo / ODD (Rojo) */\r\n}\r\n\r\n@keyframes cam-fail {\r\n\r\n    0%,\r\n    30% {\r\n        fill: #10b981;\r\n    }\r\n\r\n    /* Aún reciben red (Verde) */\r\n    35%,\r\n    100% {\r\n        fill: #94a3b8;\r\n    }\r\n\r\n    /* Estado Inalcanzable normal (Gris) */\r\n}\r\n\r\n@keyframes line-fail {\r\n\r\n    0%,\r\n    25% {\r\n        stroke: #10b981;\r\n        stroke-dasharray: none;\r\n    }\r\n\r\n    /* Conectado */\r\n    30%,\r\n    100% {\r\n        stroke: #cbd5e1;\r\n        stroke-dasharray: 4 4;\r\n    }\r\n\r\n    /* Desconectado */\r\n}\r\n\r\n@keyframes alert-pop {\r\n\r\n    0%,\r\n    25% {\r\n        opacity: 0;\r\n        transform: scale(0.5);\r\n    }\r\n\r\n    30%,\r\n    40% {\r\n        opacity: 1;\r\n        transform: scale(1.2);\r\n    }\r\n\r\n    45%,\r\n    100% {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n/* ****************************************DOWN************************************************ */\r\n/* Limitar el tamaño del SVG */\r\n.max-width-down-diagram {\r\n    max-width: 220px;\r\n}\r\n\r\n/* Asignación de animaciones */\r\n.anim-switch-down {\r\n    animation: switch-fail-down 4.5s infinite;\r\n}\r\n\r\n.anim-cam-down {\r\n    animation: cam-fail-down 4.5s infinite;\r\n}\r\n\r\n.anim-line-down {\r\n    animation: line-fail-down 4.5s infinite;\r\n}\r\n\r\n.anim-alert-down {\r\n    animation: alert-pop-down 4.5s infinite;\r\n    transform-origin: 145px 10px;\r\n}\r\n\r\n/* Keyframes con sufijo -down */\r\n@keyframes switch-fail-down {\r\n\r\n    0%,\r\n    25% {\r\n        fill: #10b981;\r\n    }\r\n\r\n    /* Verde OK */\r\n    30%,\r\n    100% {\r\n        fill: #ef4444;\r\n    }\r\n\r\n    /* Rojo ODD */\r\n}\r\n\r\n@keyframes cam-fail-down {\r\n\r\n    0%,\r\n    30% {\r\n        fill: #10b981;\r\n    }\r\n\r\n    /* Verde OK */\r\n    35%,\r\n    100% {\r\n        fill: #f472b6;\r\n    }\r\n\r\n    /* ROSA para indicar dependencia caída */\r\n}\r\n\r\n@keyframes line-fail-down {\r\n\r\n    0%,\r\n    25% {\r\n        stroke: #10b981;\r\n        stroke-dasharray: none;\r\n    }\r\n\r\n    30%,\r\n    100% {\r\n        stroke: #fbcfe8;\r\n        stroke-dasharray: 4 4;\r\n    }\r\n\r\n    /* Rosa suave para las líneas */\r\n}\r\n\r\n@keyframes alert-pop-down {\r\n\r\n    0%,\r\n    25% {\r\n        opacity: 0;\r\n        transform: scale(0.5);\r\n    }\r\n\r\n    30%,\r\n    40% {\r\n        opacity: 1;\r\n        transform: scale(1.2);\r\n    }\r\n\r\n    45%,\r\n    100% {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n/* ************************** UP ****************************** */\r\n.max-width-up-diagram {\r\n    max-width: 220px;\r\n}\r\n\r\n/* Estilo base de línea */\r\n.line-up {\r\n    stroke: #10b981;\r\n    stroke-dasharray: 8 4;\r\n    /* Línea punteada */\r\n}\r\n\r\n/* Animación de flujo de datos (hormigas marchando) */\r\n.active-flow {\r\n    animation: flow-movement 1s linear infinite;\r\n}\r\n\r\n@keyframes flow-movement {\r\n    from {\r\n        stroke-dashoffset: 24;\r\n    }\r\n\r\n    to {\r\n        stroke-dashoffset: 0;\r\n    }\r\n}\r\n\r\n/* Pulso sutil en el switch para simular \"Latido/Ping\" */\r\n.ping-pulse {\r\n    animation: ping-ring 2s ease-out infinite;\r\n    opacity: 0;\r\n}\r\n\r\n@keyframes ping-ring {\r\n    0% {\r\n        transform: scale(0.8);\r\n        opacity: 0.5;\r\n    }\r\n\r\n    100% {\r\n        transform: scale(1.8);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n/* Efecto de brillo constante en los nodos verdes */\r\n.node-up {\r\n    filter: drop-shadow(0 0 2px rgba(16, 185, 129, 0.4));\r\n}\r\n\r\n/* ***************************unknown***************************** */\r\n.max-width-unknown-diagram {\r\n    max-width: 220px;\r\n}\r\n\r\n/* Líneas en gris claro y punteadas pero sin movimiento */\r\n.line-unknown {\r\n    stroke: #cbd5e1;\r\n    stroke-dasharray: 2 2;\r\n}\r\n\r\n/* Animación de \"parpadeo\" suave para el signo de interrogación */\r\n.anim-unknown-q {\r\n    animation: unknown-fade 3s infinite ease-in-out;\r\n    transform-origin: 145px 10px;\r\n}\r\n\r\n@keyframes unknown-fade {\r\n\r\n    0%,\r\n    100% {\r\n        opacity: 0.4;\r\n        transform: scale(0.9);\r\n    }\r\n\r\n    50% {\r\n        opacity: 1;\r\n        transform: scale(1.1);\r\n    }\r\n}\r\n\r\n/* Nodos en gris neutro */\r\n.node-unknown {\r\n    fill: #94a3b8;\r\n}\r\n\r\n/* ********************************Exception************************************** */\r\n.max-width-exception-tags-diagram {\r\n    max-width: 220px;\r\n}\r\n\r\n/* Líneas verdes sólidas porque la red física está activa */\r\n.line-exception-tag-ok {\r\n    stroke: #10b981;\r\n    stroke-opacity: 0.7;\r\n}\r\n\r\n/* Sombra ligera para las etiquetas para dar efecto 3D (similar a drop-shadow) */\r\n.tag-shadow {\r\n    filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n/* Pulso sutil solo en C2 (Mantenimiento crítico) */\r\n.node-mtto-pulse {\r\n    animation: mtto-pulse 2s infinite ease-in-out;\r\n}\r\n\r\n@keyframes mtto-pulse {\r\n\r\n    0%,\r\n    100% {\r\n        filter: brightness(1);\r\n    }\r\n\r\n    50% {\r\n        filter: brightness(1.2);\r\n    }\r\n}\r\n\r\n/* Animación de levitación para las etiquetas */\r\n.anim-tag-float {\r\n    animation: tag-float 3s infinite ease-in-out;\r\n}\r\n\r\n@keyframes tag-float {\r\n\r\n    0%,\r\n    100% {\r\n        transform: translate(var(--original-x, 0px), 45px);\r\n    }\r\n\r\n    /* Usamos variables para mantener la posición X */\r\n    50% {\r\n        transform: translate(var(--original-x, 0px), 40px);\r\n    }\r\n}\r\n\r\n/* Aplicar la posición original X a cada grupo para la animación */\r\n.cfe-tag-group {\r\n    --original-x: 45px;\r\n}\r\n\r\n.mtto-tag-group {\r\n    --original-x: 105px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
